var StripeHelper = (function(apiKey) {
    
    var $ready = new $.Deferred();
    var _stripe;
    var _cardNumber;
    var _cardExpiry;
    var _cardCvc;

    var style = {
        base: {
            'font-size': '12px', 
            'color': '#333333', 
            'font-family': 'Verdana', 
            'font-weight': 'normal',
            'fontSmoothing': 'antialiased',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        }
    };

    var handlerCompleteField = function(event, field1, field2) {
        if (event.complete) {
            if (!field1._complete) {
                field1.focus();
            } else if (!field2._complete) {
                field2.focus();
            }
        }
    }

    var _loadStripe = function(parameters) {
        var script = document.createElement('script');
        script.src = "https://js.stripe.com/v3/";
        if (document.head.append) {
            document.head.append(script);
        } else {
            document.head.appendChild(script);
        }

        script.onload = function () {
            var interval = setInterval(function () {
                if (window.Stripe) {
                    clearInterval(interval);
                    _stripe = Stripe(apiKey, {
                        locale: 'en'
                    });
                    $ready.resolve(_stripe);
                    window.app && app.event && app.event.stripeLoaded && app.event.stripeLoaded();
                }
            }, 100);
        };

        script.onerror = function () {
            window.app && app.event && app.event.stripeFailed && app.event.stripeFailed();
        };

        return $ready.promise();
    }

    var _initializeHostedFields = function(stripe) {

        var elements = stripe.elements();

        _cardNumber = elements.create('cardNumber', { style: style });
        _cardNumber.mount('#card-number');

        _cardCvc = elements.create('cardCvc', { style: style });
        _cardCvc.mount('#cvv');

        _cardExpiry = elements.create('cardExpiry', { style: style });
        _cardExpiry.mount('#expiration-date');

        // Handle real-time validation errors from the card Element.
        _cardNumber.addEventListener('change', function(event) {
            handlerCompleteField(event, _cardCvc, _cardExpiry);
        });
        _cardCvc.addEventListener('change', function(event) {
            handlerCompleteField(event, _cardExpiry, _cardNumber);
        });
        _cardExpiry.addEventListener('change', function(event) {
            handlerCompleteField(event, _cardNumber, _cardCvc);
        });

        return stripe;
    }
    
    return {
        init: function() {
            if ($ready.state() === 'pending') {
                _loadStripe()
                    .then(_initializeHostedFields);
            }
        },
        getPayload: function() {
            var $result = new $.Deferred();
            _stripe.createPaymentMethod('card', _cardNumber, { /* billing_details: {name: cardholderName.value} */ })
                .then(function(result) {
                    if (result.error) {
                        $result.reject(result);
                    } else {
                        $result.resolve(result.paymentMethod.id);
                    }
                });
            return $result.promise();
        },
        handleServerResponce: function(response) {
            var $result = new $.Deferred();
            if (response.Value.response === 'use_stripe_sdk') {
                window.app && app.event && app.event.stripeThreeDSecureOpen();
                var _handle = _stripe.handleCardAction;
                var connectedAccountId = response.Value.ConnectedAccountId;
                if (connectedAccountId) {
                    var _connected_account = Stripe(apiKey, {
                        stripeAccount: connectedAccountId,
                        locale: 'en'
                    });
                    _handle = _connected_account.handleCardAction;
                }
                _handle(
                    response.Value.clientSecret
                ).then(function(result) {
                    if (result.error) {
                        window.app && app.event && app.event.stripeThreeDSecureFail(result.error.message);
                        $result.reject(result.error.message);
                    } else {
                        window.app && app.event && app.event.stripeThreeDSecurePassed();
                        $result.resolve(result.paymentIntent.id);
                    }
                });
            } else {
                $result.resolve(response);
            }
            return $result.promise();
        },
        ready: function (fn) {
            return $ready.done(fn);
        }
    }
});